import React, { useCallback } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router";

import { ReactComponent as CheckMarkIcon } from "../../Assets/Images/check-mark.svg";
import { logout } from "../../actions/Auth";
import RippleButton from "./RippleButton";

const PurchasePopup = ({ content, onDismiss, logout }) => {
  const history = useHistory();
  const isSuccess = content === "success";
  const handleClick = useCallback(() => {
    if (isSuccess) {
      logout();
      history.push("/");
    } else {
      onDismiss();
    }
  }, [isSuccess, logout, onDismiss, history]);

  return (
    <Modal
      show={!!content}
      centered={true}
      animation={false}
      onHide={onDismiss}
      {...(isSuccess && { backdrop: "static" })}
      dialogClassName="onboarding-modal justify-content-center text-center"
      data-testid="onboarding-modal"
    >
      {isSuccess ? <CheckMarkIcon /> : null}
      <Modal.Header className="justify-content-center border-0">
        <Modal.Title className="font-weight-bold">
          {isSuccess ? "Great!" : "Failed!"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body bsPrefix="modal-body text-center">
        {isSuccess
          ? "We’ve sent you an email with your login information and next steps to get your QR code menu live!"
          : content}
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0">
        <RippleButton onClick={handleClick}>Okay</RippleButton>
      </Modal.Footer>
    </Modal>
  );
};

PurchasePopup.propTypes = {
  content: PropTypes.string,
  onDismiss: PropTypes.func,
  logout: PropTypes.func.isRequired,
};

export default connect(null, { logout })(PurchasePopup);
